<app-widget-header
  (removeWidget)="removeItem.emit($event)"
  [buttons]="widgetButtons"
  [editMode]="editMode"
  [gridsterItem]="gridsterItem"
  [hideEdit]="false"
  [widgetTitle]="name"></app-widget-header>


<app-three-dim-model-form
  *ngIf="popupOpen"
  #threeDimModelFormComponent
  (popupOpen)="popupOpen = $event"
  (saveModelRequest)="saveModel($event)"
  [modelToEdit]="modelToEdit"
  [popupOpen]="popupOpen">
</app-three-dim-model-form>


<div *ngIf="modelsToView.length > 0" class="gridster-item-content widgetContent threeDimModel">

  <div style="position:relative; width: 100%; height: 100%">
    <div class="threeDimContainer">
      <dx-tab-panel
        (onItemRendered)="dispatchResizeEvent()"
        (onSelectionChanged)="initializeTabMetrics()"
        [(selectedIndex)]="currentSelectedModelIndex"
        [animationEnabled]="true"
        [deferRendering]="true"
        [itemTitleTemplate]="'3dTitleTemplate'"
        [repaintChangesOnly]="true"
        [scrollByContent]="true"
        [scrollingEnabled]="true"
        [showNavButtons]="true"
        [style.height]="'100%'"
        [swipeEnabled]="false">

        <dxi-item
          *ngFor="let theThreeDimModel of modelsToView; index as index"
          [disabled]="currentSelectedModelIndex !== index && loadingWorkflowStatus !== FileLoadingWorkflowEnum.COMPLETED && loadingWorkflowStatus !== FileLoadingWorkflowEnum.ERROR && loadingWorkflowStatus !== FileLoadingWorkflowEnum.NO_FILE_FOUND"
          [titleTemplate]="'3dTitleTemplate'"
          [title]="theThreeDimModel.fileName">
          <div *dxTemplate class="threeDimTab">

            <app-three-dim-viewer
              (loadingWorkflowStatus)="loadingWorkflowStatus = $event"
              [isWidget]="true"
              [keyMeshesList]="getMapForTDViewer(theThreeDimModel.metricsMap)"
              [style.height.%]="100"
              [theThreeDimModel]="theThreeDimModel">
            </app-three-dim-viewer>


            <div class="tdScrollHandleContainer"
                 *ngIf="appService.isMobileScreen()"
                 [style.bottom.px]="showMetricPanel(theThreeDimModel)? 100 : 0">
              <div class="tdScrollHandle"></div>
            </div>

            <div *ngIf="showMetricPanel(theThreeDimModel)"
                 [style.background-color]="getStylizedCSSVariable('--dx-color-main-bg').concat('90')"
                 class="measurePanel">
              <span class="measurePanelTitle">{{ "WIDGETS.THREE_DIM.MEASURE_PANEL" | translate }}</span>
              <dx-scroll-view direction="vertical">
                <div class="measurePanelMeasures">
                  <div *ngFor="let measure of theThreeDimModel.measurePanelMetrics">
                    {{ measure.partitionName }} > {{ measure.deviceName }} > {{ measure.name }}
                    : <b>{{ appService.getParsedMetricValue(measure) }}</b> {{ measure.dataUnit }}
                  </div>
                </div>
              </dx-scroll-view>
            </div>

          </div>

        </dxi-item>
        <div *dxTemplate="let titleTemplate of '3dTitleTemplate'; index as index"
             class="threeDimTitleWrapper">
          <span>{{ titleTemplate.title }}</span>
          <dx-button
            (onClick)="editingIndex = index; editModel(titleTemplate, index); $event.event!.stopPropagation()"
            *ngIf="editMode"
            [height]="25"
            [style.margin-left.px]="5"
            [width]="25"
            stylingMode="text">
            <i class="vr-ic_fluent_edit_24_regular" style="font-size: 20px"></i>
          </dx-button>
          <dx-button
            (onClick)="deleteModel(titleTemplate, index); $event.event!.stopPropagation()"
            *ngIf="editMode"
            [height]="25"
            [style.margin-left.px]="5"
            [width]="25"
            stylingMode="text">
            <i class="vr-ic_fluent_delete_24_regular" style="font-size: 20px"></i>
          </dx-button>
        </div>
      </dx-tab-panel>
    </div>
  </div>
</div>

<app-widget-placeholder (configurationCallback)="this.createModel()" *ngIf="modelsToView.length === 0"
                        icon="compass_northwest"></app-widget-placeholder>
